module.exports = __webpack_public_path__ + "static/media/bag-hire-upgraded.f1893fb8.png";